<template>
  <Dialog
    :visible.sync="visible"
    header="Follow-up emails"
    :modal="true"
    :style="{ width: '460px' }"
  >
    <p id="followupRevisionQuestion">
      Follow-up emails were stopped by hand on the previous version. Start them for this revision?
    </p>
    <template #footer>
      <Button id="followupRevisionNo" label="No" icon="pi pi-times" class="p-button-text" :disabled="busy" @click="no" />
      <Button id="followupRevisionYes" label="Yes, start them" icon="pi pi-check" class="p-button-text" :disabled="busy" @click="yes" />
    </template>
  </Dialog>
</template>

<script>
// D11. Mounted once in App.vue. Listens for a booked quote version, asks byOpp whether the
// previous version's follow-ups were stopped by hand, and if so asks the user. A failure
// of the byOpp check is silent (console only): the quote save has already succeeded.
import EventBus from '@/event-bus'
import FollowupService, { errorMessage } from '@/service/FollowupService'
import { QUOTE_VERSION_BOOKED, FOLLOWUP_CHANGED, shouldAsk } from './followupRevision'

export default {
  data: () => ({
    followupService: new FollowupService(),
    visible: false,
    oppId: null,
    quoteVerId: null,
    busy: false
  }),
  created() {
    EventBus.$on(QUOTE_VERSION_BOOKED, this.check)
  },
  beforeDestroy() {
    EventBus.$off(QUOTE_VERSION_BOOKED, this.check)
  },
  methods: {
    check(payload) {
      var p = payload || {}
      return this.followupService.byOpp(p.oppId)
        .then(data => {
          if (shouldAsk(data, p.quoteVerId)) {
            this.oppId = p.oppId
            this.quoteVerId = data.quoteVerId
            this.visible = true
          }
        })
        .catch(err => {
          console.error('follow-up: could not check the revision for enquiry ' + p.oppId, err)
        })
    },
    no() {
      this.visible = false
      this.oppId = null
      this.quoteVerId = null
    },
    yes() {
      var id = this.quoteVerId
      var oppId = this.oppId
      this.busy = true
      return this.followupService.enrol(id)
        .then(() => {
          EventBus.$emit(FOLLOWUP_CHANGED, { oppId: oppId, quoteVerId: id })
          this.$toast.add({
            severity: 'success',
            summary: 'Follow-up emails',
            detail: 'Follow-up emails started for this revision.',
            life: 5000
          })
        })
        .catch(err => {
          var body = err && err.response && err.response.data
          this.$toast.add({
            severity: 'error',
            summary: 'Follow-up emails',
            detail: errorMessage(err, (body && body.result) || 'Follow-up emails could not be started.'),
            life: 5000
          })
        })
        .finally(() => {
          this.busy = false
          this.visible = false
          this.oppId = null
          this.quoteVerId = null
        })
    }
  }
}
</script>
